import { GeocodeResult } from '../types/companyLocation';

const getAddressComponent = (
  components: google.maps.GeocoderAddressComponent[],
  type: string
): string | null => {
  const component = components.find((entry) => entry.types.includes(type));
  return component?.long_name ?? null;
};

export const reverseGeocodeWithGoogleMaps = (
  latitude: number,
  longitude: number
): Promise<GeocodeResult> =>
  new Promise((resolve, reject) => {
    if (typeof google === 'undefined' || !google.maps?.Geocoder) {
      reject(new Error('Google Maps is not loaded yet.'));
      return;
    }

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        reject(new Error(`Google Maps could not resolve this location (${status})`));
        return;
      }

      if (!results || results.length === 0) {
        reject(new Error('Google Maps returned no results for this location'));
        return;
      }

      const bestResult = results[0];
      const components = bestResult.address_components ?? [];
      const streetNumber = getAddressComponent(components, 'street_number');
      const route = getAddressComponent(components, 'route');
      const city =
        getAddressComponent(components, 'locality') ??
        getAddressComponent(components, 'postal_town') ??
        getAddressComponent(components, 'administrative_area_level_2') ??
        getAddressComponent(components, 'sublocality') ??
        getAddressComponent(components, 'sublocality_level_1');
      const state = getAddressComponent(components, 'administrative_area_level_1');
      const postalCode = getAddressComponent(components, 'postal_code');
      const country = getAddressComponent(components, 'country');
      const address = [route, streetNumber].filter(Boolean).join(' ').trim() || bestResult.formatted_address;
      const plusCode = (bestResult as any).plus_code?.global_code ?? null;

      resolve({
        latitude,
        longitude,
        address: address || null,
        city,
        state,
        postalCode,
        country,
        plusCode,
      });
    });
  });
